import ProgressiveImage from '../common/ProgressiveImage'
import useMap from './useMap'
import UserPoint from './UserPoint/UserPoint'
import styles from './Map.module.scss'
import useUserLocation from '../../features/userLocation/useUserLocation'
import POIPoints from './POIPoints/POIPoints'
import { Loading } from '../common'

const Map = () => {
  useUserLocation()

  const {
    map,
    mapImg,
    imgRef,
    imgSize,
    updateSize,
    allowUserClick,
    loading,
    handlers,
  } = useMap()
  const { handleMapClick } = handlers

  if (loading)
    return (
      <div className={styles.mapRootLoading}>
        <Loading loading={true} message="Loading map…" />
      </div>
    )

  return (
    <div className={styles.mapRoot} style={{ position: 'relative' }}>
      {mapImg && (
        <div onClick={allowUserClick ? handleMapClick : undefined}>
          {/* {process.env.NODE_ENV === 'development' && <DebugPanel />} */}
          <ProgressiveImage
            src={mapImg}
            // alt={`${map?.map} map`}
            ref={imgRef}
            className={styles.mapImg}
            onLoad={updateSize}
          />
          {imgSize.width > 0 && map?.boundingBox && (
            <>
              <UserPoint
                mapBounds={map.boundingBox}
                imageWidth={imgSize.width}
                imageHeight={imgSize.height}
              />
              <POIPoints
                mapBounds={map.boundingBox}
                imageWidth={imgSize.width}
                imageHeight={imgSize.height}
              />
            </>
          )}
        </div>
      )}
    </div>
  )
}

export default Map
